var _a;
import { Ribbon_Health_Language_Search_Name } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Ribbon_Health_Language_Search_Name.Abkhazian] = 'Abkhazian',
    _a[Ribbon_Health_Language_Search_Name.Afar] = 'Afar',
    _a[Ribbon_Health_Language_Search_Name.Afrikaans] = 'Afrikaans',
    _a[Ribbon_Health_Language_Search_Name.Akan] = 'Akan',
    _a[Ribbon_Health_Language_Search_Name.Albanian] = 'Albanian',
    _a[Ribbon_Health_Language_Search_Name.Amharic] = 'Amharic',
    _a[Ribbon_Health_Language_Search_Name.Arabic] = 'Arabic',
    _a[Ribbon_Health_Language_Search_Name.Aragonese] = 'Aragonese',
    _a[Ribbon_Health_Language_Search_Name.Armenian] = 'Armenian',
    _a[Ribbon_Health_Language_Search_Name.Assamese] = 'Assamese',
    _a[Ribbon_Health_Language_Search_Name.Avaric] = 'Avaric',
    _a[Ribbon_Health_Language_Search_Name.Avestan] = 'Avestan',
    _a[Ribbon_Health_Language_Search_Name.Aymara] = 'Aymara',
    _a[Ribbon_Health_Language_Search_Name.Azerbaijani] = 'Azerbaijani',
    _a[Ribbon_Health_Language_Search_Name.Bambara] = 'Bambara',
    _a[Ribbon_Health_Language_Search_Name.Bashkir] = 'Bashkir',
    _a[Ribbon_Health_Language_Search_Name.Basque] = 'Basque',
    _a[Ribbon_Health_Language_Search_Name.Belarusian] = 'Belarusian',
    _a[Ribbon_Health_Language_Search_Name.Bengali] = 'Bengali',
    _a[Ribbon_Health_Language_Search_Name.Bislama] = 'Bislama',
    _a[Ribbon_Health_Language_Search_Name.Bosnian] = 'Bosnian',
    _a[Ribbon_Health_Language_Search_Name.Breton] = 'Breton',
    _a[Ribbon_Health_Language_Search_Name.Bulgarian] = 'Bulgarian',
    _a[Ribbon_Health_Language_Search_Name.Burmese] = 'Burmese',
    _a[Ribbon_Health_Language_Search_Name.Cambodian] = 'Cambodian',
    _a[Ribbon_Health_Language_Search_Name.Chamorro] = 'Chamorro',
    _a[Ribbon_Health_Language_Search_Name.Chechen] = 'Chechen',
    _a[Ribbon_Health_Language_Search_Name.Chinese] = 'Chinese',
    _a[Ribbon_Health_Language_Search_Name.Chuvash] = 'Chuvash',
    _a[Ribbon_Health_Language_Search_Name.Cornish] = 'Cornish',
    _a[Ribbon_Health_Language_Search_Name.Corsican] = 'Corsican',
    _a[Ribbon_Health_Language_Search_Name.Cree] = 'Cree',
    _a[Ribbon_Health_Language_Search_Name.Croatian] = 'Croatian',
    _a[Ribbon_Health_Language_Search_Name.Czech] = 'Czech',
    _a[Ribbon_Health_Language_Search_Name.Danish] = 'Danish',
    _a[Ribbon_Health_Language_Search_Name.Dzongkha] = 'Dzongkha',
    _a[Ribbon_Health_Language_Search_Name.English] = 'English',
    _a[Ribbon_Health_Language_Search_Name.Esperanto] = 'Esperanto',
    _a[Ribbon_Health_Language_Search_Name.Estonian] = 'Estonian',
    _a[Ribbon_Health_Language_Search_Name.Ewe] = 'Ewe',
    _a[Ribbon_Health_Language_Search_Name.Faroese] = 'Faroese',
    _a[Ribbon_Health_Language_Search_Name.Fijian] = 'Fijian',
    _a[Ribbon_Health_Language_Search_Name.Finnish] = 'Finnish',
    _a[Ribbon_Health_Language_Search_Name.French] = 'French',
    _a[Ribbon_Health_Language_Search_Name.Fulah] = 'Fulah',
    _a[Ribbon_Health_Language_Search_Name.Galician] = 'Galician',
    _a[Ribbon_Health_Language_Search_Name.Ganda] = 'Ganda',
    _a[Ribbon_Health_Language_Search_Name.Georgian] = 'Georgian',
    _a[Ribbon_Health_Language_Search_Name.German] = 'German',
    _a[Ribbon_Health_Language_Search_Name.Guarani] = 'Guarani',
    _a[Ribbon_Health_Language_Search_Name.Gujarati] = 'Gujarati',
    _a[Ribbon_Health_Language_Search_Name.Hausa] = 'Hausa',
    _a[Ribbon_Health_Language_Search_Name.Hebrew] = 'Hebrew',
    _a[Ribbon_Health_Language_Search_Name.Herero] = 'Herero',
    _a[Ribbon_Health_Language_Search_Name.Hindi] = 'Hindi',
    _a[Ribbon_Health_Language_Search_Name.Hungarian] = 'Hungarian',
    _a[Ribbon_Health_Language_Search_Name.Icelandic] = 'Icelandic',
    _a[Ribbon_Health_Language_Search_Name.Ido] = 'Ido',
    _a[Ribbon_Health_Language_Search_Name.Igbo] = 'Igbo',
    _a[Ribbon_Health_Language_Search_Name.Indonesian] = 'Indonesian',
    _a[Ribbon_Health_Language_Search_Name.Inuktitut] = 'Inuktitut',
    _a[Ribbon_Health_Language_Search_Name.Inupiaq] = 'Inupiaq',
    _a[Ribbon_Health_Language_Search_Name.Irish] = 'Irish',
    _a[Ribbon_Health_Language_Search_Name.Italian] = 'Italian',
    _a[Ribbon_Health_Language_Search_Name.Japanese] = 'Japanese',
    _a[Ribbon_Health_Language_Search_Name.Javanese] = 'Javanese',
    _a[Ribbon_Health_Language_Search_Name.Kannada] = 'Kannada',
    _a[Ribbon_Health_Language_Search_Name.Kanuri] = 'Kanuri',
    _a[Ribbon_Health_Language_Search_Name.Kashmiri] = 'Kashmiri',
    _a[Ribbon_Health_Language_Search_Name.Kazakh] = 'Kazakh',
    _a[Ribbon_Health_Language_Search_Name.Kinyarwanda] = 'Kinyarwanda',
    _a[Ribbon_Health_Language_Search_Name.Komi] = 'Komi',
    _a[Ribbon_Health_Language_Search_Name.Kongo] = 'Kongo',
    _a[Ribbon_Health_Language_Search_Name.Korean] = 'Korean',
    _a[Ribbon_Health_Language_Search_Name.Kurdish] = 'Kurdish',
    _a[Ribbon_Health_Language_Search_Name.Lao] = 'Lao',
    _a[Ribbon_Health_Language_Search_Name.Latin] = 'Latin',
    _a[Ribbon_Health_Language_Search_Name.Latvian] = 'Latvian',
    _a[Ribbon_Health_Language_Search_Name.Lingala] = 'Lingala',
    _a[Ribbon_Health_Language_Search_Name.Lithuanian] = 'Lithuanian',
    _a[Ribbon_Health_Language_Search_Name.Macedonian] = 'Macedonian',
    _a[Ribbon_Health_Language_Search_Name.Malagasy] = 'Malagasy',
    _a[Ribbon_Health_Language_Search_Name.Malay] = 'Malay',
    _a[Ribbon_Health_Language_Search_Name.Malayalam] = 'Malayalam',
    _a[Ribbon_Health_Language_Search_Name.Maltese] = 'Maltese',
    _a[Ribbon_Health_Language_Search_Name.Manx] = 'Manx',
    _a[Ribbon_Health_Language_Search_Name.Maori] = 'Maori',
    _a[Ribbon_Health_Language_Search_Name.Marathi] = 'Marathi',
    _a[Ribbon_Health_Language_Search_Name.Marshallese] = 'Marshallese',
    _a[Ribbon_Health_Language_Search_Name.Mongolian] = 'Mongolian',
    _a[Ribbon_Health_Language_Search_Name.Nauru] = 'Nauru',
    _a[Ribbon_Health_Language_Search_Name.Ndonga] = 'Ndonga',
    _a[Ribbon_Health_Language_Search_Name.Nepali] = 'Nepali',
    _a[Ribbon_Health_Language_Search_Name.Norwegian] = 'Norwegian',
    _a[Ribbon_Health_Language_Search_Name.Ojibwa] = 'Ojibwa',
    _a[Ribbon_Health_Language_Search_Name.Oriya] = 'Oriya',
    _a[Ribbon_Health_Language_Search_Name.Oromo] = 'Oromo',
    _a[Ribbon_Health_Language_Search_Name.Pali] = 'Pali',
    _a[Ribbon_Health_Language_Search_Name.Persian] = 'Persian',
    _a[Ribbon_Health_Language_Search_Name.Polish] = 'Polish',
    _a[Ribbon_Health_Language_Search_Name.Portuguese] = 'Portuguese',
    _a[Ribbon_Health_Language_Search_Name.Quechua] = 'Quechua',
    _a[Ribbon_Health_Language_Search_Name.Romansh] = 'Romansh',
    _a[Ribbon_Health_Language_Search_Name.Rundi] = 'Rundi',
    _a[Ribbon_Health_Language_Search_Name.Russian] = 'Russian',
    _a[Ribbon_Health_Language_Search_Name.Samoan] = 'Samoan',
    _a[Ribbon_Health_Language_Search_Name.Sango] = 'Sango',
    _a[Ribbon_Health_Language_Search_Name.Sanskrit] = 'Sanskrit',
    _a[Ribbon_Health_Language_Search_Name.Sardinian] = 'Sardinian',
    _a[Ribbon_Health_Language_Search_Name.Serbian] = 'Serbian',
    _a[Ribbon_Health_Language_Search_Name.Shona] = 'Shona',
    _a[Ribbon_Health_Language_Search_Name.Sindhi] = 'Sindhi',
    _a[Ribbon_Health_Language_Search_Name.Slovak] = 'Slovak',
    _a[Ribbon_Health_Language_Search_Name.Slovenian] = 'Slovenian',
    _a[Ribbon_Health_Language_Search_Name.Somali] = 'Somali',
    _a[Ribbon_Health_Language_Search_Name.Spanish] = 'Spanish',
    _a[Ribbon_Health_Language_Search_Name.Sundanese] = 'Sundanese',
    _a[Ribbon_Health_Language_Search_Name.Swahili] = 'Swahili',
    _a[Ribbon_Health_Language_Search_Name.Swati] = 'Swati',
    _a[Ribbon_Health_Language_Search_Name.Swedish] = 'Swedish',
    _a[Ribbon_Health_Language_Search_Name.Tagalog] = 'Tagalog',
    _a[Ribbon_Health_Language_Search_Name.Tahitian] = 'Tahitian',
    _a[Ribbon_Health_Language_Search_Name.Tajik] = 'Tajik',
    _a[Ribbon_Health_Language_Search_Name.Tamil] = 'Tamil',
    _a[Ribbon_Health_Language_Search_Name.Tatar] = 'Tatar',
    _a[Ribbon_Health_Language_Search_Name.Telugu] = 'Telugu',
    _a[Ribbon_Health_Language_Search_Name.Thai] = 'Thai',
    _a[Ribbon_Health_Language_Search_Name.Tibetan] = 'Tibetan',
    _a[Ribbon_Health_Language_Search_Name.Tigrinya] = 'Tigrinya',
    _a[Ribbon_Health_Language_Search_Name.Tsonga] = 'Tsonga',
    _a[Ribbon_Health_Language_Search_Name.Tswana] = 'Tswana',
    _a[Ribbon_Health_Language_Search_Name.Turkish] = 'Turkish',
    _a[Ribbon_Health_Language_Search_Name.Turkmen] = 'Turkmen',
    _a[Ribbon_Health_Language_Search_Name.Twi] = 'Twi',
    _a[Ribbon_Health_Language_Search_Name.Ukrainian] = 'Ukrainian',
    _a[Ribbon_Health_Language_Search_Name.Urdu] = 'Urdu',
    _a[Ribbon_Health_Language_Search_Name.Uzbek] = 'Uzbek',
    _a[Ribbon_Health_Language_Search_Name.Venda] = 'Venda',
    _a[Ribbon_Health_Language_Search_Name.Vietnamese] = 'Vietnamese',
    _a[Ribbon_Health_Language_Search_Name.Walloon] = 'Walloon',
    _a[Ribbon_Health_Language_Search_Name.Welsh] = 'Welsh',
    _a[Ribbon_Health_Language_Search_Name.Wolof] = 'Wolof',
    _a[Ribbon_Health_Language_Search_Name.Xhosa] = 'Xhosa',
    _a[Ribbon_Health_Language_Search_Name.Yiddish] = 'Yiddish',
    _a[Ribbon_Health_Language_Search_Name.Yoruba] = 'Yoruba',
    _a[Ribbon_Health_Language_Search_Name.Zulu] = 'Zulu',
    _a);
export var RibbonHealthLanguageSearchNameEnum = {
    name: 'Ribbon_Health_Language_Search_Name',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
